module.exports = __webpack_public_path__ + "static/implant01-da670aa3eb18b4eb09eee63b7a04ef48.jpg";